/**
 * Do not edit directly
 * Generated on Tue, 24 Jan 2023 12:01:59 GMT
 */

export const formfieldPaddingHorizontal = "16px";
export const formfieldBackgroundColor = "var(--color-control-background, rgba(25, 28, 52, 0.1))";
export const formfieldBackgroundColorFocus = "transparent";
export const formfieldBackgroundColorError = "var(--color-control-background-error, rgba(255, 85, 85, 0.08))";
export const formfieldBorderWidth = "1px";
export const formfieldBorderStyle = "solid";
export const formfieldBorderColor = "transparent";
export const formfieldBorderColorHover = "var(--color-border-focus, #212121)";
export const formfieldBorderColorFocus = "var(--color-border-focus, #212121)";
export const formfieldBorderColorError = "var(--color-border-error, #ff5555)";
export const formfieldBorderRadius = "12px";
export const formfieldDisabledLabelColor = "var(--color-text-disabled, rgba(25, 28, 52, 0.48))";
export const formfieldDisabledTextColor = "var(--color-text-disabled, rgba(25, 28, 52, 0.48))";
export const formfieldDisabledHelperTextColor = "var(--color-text-disabled, rgba(25, 28, 52, 0.48))";
export const formfieldInvalidBackgroundColor = "var(--color-control-background-error, rgba(255, 85, 85, 0.08))";
export const formfieldInvalidBorderColor = "var(--color-border-error, #ff5555)";
export const formfieldFocusedBackgroundColor = "transparent";
export const formfieldFocusedBorderColor = "var(--color-border-focus, #212121)";
export const formfieldHoverBorderColor = "var(--color-border-focus, #212121)";
export const formfieldLabelColor = "var(--color-text-inactive, rgba(25, 28, 52, 0.7))";
export const formfieldLabelColorDisabled = "var(--color-text-disabled, rgba(25, 28, 52, 0.48))";
export const formfieldPlaceholderColor = "var(--color-text-disabled, rgba(25, 28, 52, 0.48))";
export const formfieldTextColor = "var(--color-text-active, rgba(9, 11, 22, 0.94))";
export const formfieldTextColorDisabled = "var(--color-text-disabled, rgba(25, 28, 52, 0.48))";
export const formfieldSubscriptHeight = "16px";
export const formfieldSubscriptMarginTop = "4px";
export const formfieldSubscriptFontSize = "13px";
export const formfieldSubscriptFontWeight = 400;
export const formfieldSubscriptFontLineHeight = "16px";
export const formfieldSubscriptFontLetterSpacing = "0.2px";
export const formfieldHintColor = "var(--color-text-inactive, rgba(25, 28, 52, 0.7))";
export const formfieldHintColorDisabled = "var(--color-text-disabled, rgba(25, 28, 52, 0.48))";
export const formfieldHelperTextColor = "var(--color-text-inactive, rgba(25, 28, 52, 0.7))";
export const formfieldErrorTextColor = "var(--color-status-error, #ff5555)";
export const formfieldSmallTextFontSize = "15px";
export const formfieldSmallTextFontWeight = 400;
export const formfieldSmallTextFontLineHeight = "18px";
export const formfieldSmallTextFontLetterSpacing = "0.2px";
export const formfieldMediumTextFontSize = "17px";
export const formfieldMediumTextFontWeight = 400;
export const formfieldMediumTextFontLineHeight = "22px";
export const formfieldMediumTextFontLetterSpacing = "0.2px";
export const formfieldMediumLabelFontSize = "17px";
export const formfieldMediumLabelFontSizeFloated = "13px";
export const formfieldMediumLabelFontWeight = 400;
export const formfieldMediumLabelFontLineHeight = "22px";
export const formfieldMediumLabelFontLineHeightFloated = "16px";
export const formfieldMediumLabelFloatedFontSize = "13px";
export const formfieldMediumLabelFloatedFontLineHeight = "16px";